/** Canonical child rail selection. Mirrored byte-for-byte into web/lib/railSelection.ts;
 * tests/contract/webMirrorContracts.test.ts guards the browser build boundary. */

/** A child owns rail space while running or while its terminal result awaits collection by the parent. */
export function uncollectedChildResult(
  run: { status: string; resultDelivery?: string },
): boolean {
  return run.status === 'running' || run.resultDelivery === 'pending';
}
